import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { LocaldataService } from '../../service/localdata/localdata.service';

import { NotificationDetailPage } from '../../pages/notification-detail/notification-detail.page';
import { RentalagreementPage } from '../../pages/forms/rentalagreement/rentalagreement.page';
import { RentalagreementAcceptPage } from '../../pages/forms/rentalagreement-accept/rentalagreement-accept.page';


@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.scss'],
})
export class NotificationListComponent implements OnInit {

  constructor(private localData: LocaldataService, private modalCtrl: ModalController, private alertCtrl: AlertController) { }

  ngOnInit() { }


  async showNotification(notification, notificationdata) {
    console.log('notificationdata', notification)
    //this.modalCtrl.create(FileOpenPage, )

    if (notification.action == 'openRentalagreement') {
      let modal = await this.modalCtrl.create({
        component: RentalagreementAcceptPage,
        componentProps: {
          modalCtrl: this.modalCtrl,
          notification: notification
        },
        backdropDismiss: true,
      });


      notificationdata.displayNumber = notificationdata.notificationdata.filter(x => x.read == false).length;

      if (!notification.read) {
        notification.read = true;
        this.localData.updateNotificationReadRemote(notification);
      }

      await modal.present();




      //if(notification.action=='openTransferagreement'){
      /*let profileModal = this.modalCtrl.create(FormsTransferagreementAcceptPage, { notification: notification });
      notificationdata.displayNumber = notificationdata.notificationdata.filter(x => x.read == false).length;

      if(!notification.read){
        notification.read = true;
        this.localData.updateNotificationReadRemote(notification).subscribe();
      }

      profileModal.present().then(function () {
      });
    }else if(notification.action=='openRentalagreement'){
      let profileModal = this.modalCtrl.create(FormsRentalagreementAcceptPage, { notification: notification });
      notificationdata.displayNumber = notificationdata.notificationdata.filter(x => x.read == false).length;

      if(!notification.read){
        notification.read = true;
        this.localData.updateNotificationReadRemote(notification).subscribe();
      }

      profileModal.present().then(function () {
      });
    }else if(notification.action=='openExchangeagreement'){
      let profileModal = this.modalCtrl.create(FormsExchangeagreementAcceptPage, { notification: notification });
      notificationdata.displayNumber = notificationdata.notificationdata.filter(x => x.read == false).length;

      if(!notification.read){
        notification.read = true;
        this.localData.updateNotificationReadRemote(notification).subscribe();
      }

      profileModal.present().then(function () {
      });
    }else{*/


      /*
  
        if(!notification.read){
          notification.read = true;
          //let call = this.localData.updateNotificationReadRemote(notification).subscribe( x => {
  
         // });
        }
  
        */


    } else {

      this.localData.updateNotificationReadRemote(notification);
      let profileModal = await this.modalCtrl.create(
        {
          component: NotificationDetailPage,
          componentProps: {
            notification: notification,
            modalCtrl: this.modalCtrl
          },
        });
      profileModal.present();

      if (!notification.read) {
        notification.read = true;
        this.localData.updateNotificationReadRemote(notification);
      }

      notificationdata.displayNumber = notificationdata.notificationdata.filter(x => x.read == false).length;

    }
  }

}
